import { render, staticRenderFns } from "./YtShortsMod.vue?vue&type=template&id=505d0046"
import script from "./YtShortsMod.vue?vue&type=script&lang=js"
export * from "./YtShortsMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports